module.exports = __webpack_public_path__ + "static/media/terrain-concrete-01.1ac1a6c3.svg";